export default __webpack_public_path__ + "static/media/48.62b60607.jpeg";